module.exports = __webpack_public_path__ + "img/cb3eab3.svg";